<template>
  <div class="admin-settings">
    <header-title :title="title"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <br />
    <v-container fluid>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Logo :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="logoImage"
              :type="'logo'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.icons.logo)"
                @error="input.icons.logo = fallbackImage"
                :alt="input.icons.logo"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Favicon :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="faviconImage"
              :type="'favicon'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.icons.favicon)"
                @error="input.icons.favicon = fallbackImage"
                :alt="input.icons.favicon"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Fondo de la Home :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="backgroundImage"
              :type="'background'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.icons.background)"
                @error="input.icons.background = fallbackImage"
                :alt="input.icons.background"
              />
            </div>
          </v-col>
        </v-row>

        <v-row class="mb-5">
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Icono Notificación :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="notificationImage"
              :type="'notification'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.icons.notification)"
                @error="input.icons.notification = fallbackImage"
                alt="nput.icons.notification"
              />
            </div>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row v-if="isHomeVersionPremium">
          <v-col cols="12">
            <v-subheader class="px-0 px-sm-1">
              <h2>
                <b>Imagenes de Cartas Principales</b>
              </h2>
            </v-subheader>
          </v-col>
        </v-row>

        <v-row v-if="isHomeVersionPremium">
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Comida : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="comidaImage"
              :type="'comida'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.menus.comida)"
                @error="input.menus.comida = fallbackImage"
                :alt="input.menus.comida"
              />
            </div>
          </v-col>
        </v-row>

        <v-row v-if="isHomeVersionPremium">
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Bebida : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="bebidaImage"
              :type="'bebida'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.menus.bebida)"
                @error="input.menus.bebida = fallbackImage"
                :alt="input.menus.bebida"
              />
            </div>
          </v-col>
        </v-row>

        <v-row class="mb-5" v-if="isHomeVersionPremium">
          <v-col cols="12" sm="2" class="py-0 py-sm-1">
            <v-subheader class="px-0 px-sm-1"> Postre : </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
            <FileInput
              :value="postreImage"
              :type="'postre'"
              @setImageUrl="setImageUrl($event)"
            />
          </v-col>
          <v-col cols="12" sm="1" class="py-0 py-sm-1 d-flex">
            <div class="icons-img">
              <img
                :src="showImageOrFallbackImage(input.menus.postre)"
                @error="input.menus.postre = fallbackImage"
                :alt="input.menus.postre"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center">
            <div class="my-2 mr-5">
              <v-btn
                dense
                outlined
                @click="onSaveSetting"
                type="button"
                :style="adminNavigationBackTheme"
              >
                Guardar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import FileInput from "@/components/common/FileInput";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { getSettingById, saveSetting } from "@/collections/settings";

export default {
  name: "Settings-Images",
  components: { Loader, FileInput, HeaderTitle },
  mixins: [firebaseMixin],
  data() {
    return {
      dialogLoader: false,
      title: "Imágenes",
      input: {
        icons: {
          background: "",
          favicon: "",
          logo: "",
          notification: ""
        },
        menus: {
          comida: "",
          bebida: "",
          postre: ""
        },
        colors: {
          general: {
            primaryColor: "",
            secondaryColor: ""
          },
          comida: {
            primaryColor: "",
            secondaryColor: ""
          },
          bebida: {
            primaryColor: "",
            secondaryColor: ""
          },
          postre: {
            primaryColor: "",
            secondaryColor: ""
          }
        }
      }
    };
  },
  computed: {
    backgroundImage() {
      if (!this.input.icons.background) {
        return null;
      }

      return new File(
        [this.input.icons.background],
        this.input.icons.background
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    logoImage() {
      if (!this.input.icons.logo) {
        return null;
      }

      return new File(
        [this.input.icons.logo],
        this.input.icons.logo
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    faviconImage() {
      if (!this.input.icons.favicon) {
        return null;
      }

      return new File(
        [this.input.icons.favicon],
        this.input.icons.favicon
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    notificationImage() {
      if (!this.input.icons.notification) {
        return null;
      }

      return new File(
        [this.input.icons.notification],
        this.input.icons.notification
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    comidaImage() {
      if (!this.input.menus.comida) {
        return null;
      }

      return new File(
        [this.input.menus.comida],
        this.input.menus.comida
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    bebidaImage() {
      if (!this.input.menus.bebida) {
        return null;
      }

      return new File(
        [this.input.menus.bebida],
        this.input.menus.bebida
          .split("/")
          .pop()
          .split("?")[0]
      );
    },
    postreImage() {
      if (!this.input.menus.postre) {
        return null;
      }

      return new File(
        [this.input.menus.postre],
        this.input.menus.postre
          .split("/")
          .pop()
          .split("?")[0]
      );
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.icons === undefined) {
          self.input = {
            ...self.input,
            icons: {
              background: "",
              favicon: "",
              logo: "",
              notification: ""
            }
          };
        }

        if (self.input.menus === undefined) {
          self.input = {
            ...self.input,
            menus: {
              comida: "",
              bebida: "",
              postre: ""
            }
          };
        }
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    },
    setImageUrl(data) {
      if (data.type === "background") {
        this.input.icons.background = data.url;
      } else if (data.type === "favicon") {
        this.input.icons.favicon = data.url;
      } else if (data.type === "logo") {
        this.input.icons.logo = data.url;
      } else if (data.type === "notification") {
        this.input.icons.notification = data.url;
      } else if (data.type === "comida") {
        this.input.menus.comida = data.url;
      } else if (data.type === "bebida") {
        this.input.menus.bebida = data.url;
      } else {
        this.input.menus.postre = data.url;
      }
      this.$forceUpdate();
    },
    async onSaveSetting() {
      await saveSetting("settings", {
        ...this.input
      });

      this.showSuccessMessage("Imágenes guardadas");
    }
  }
};
</script>

<style scoped lang="scss">
.icons-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
  min-width: 100px;
}
.icons-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
